import { gql } from 'apollo-boost';

export const REMOVE_GROQ_KEY = gql`
    mutation RemoveGroqKey($data: RemoveGroqKeyInput!) {
        removeGroqKey(data: $data) {
            __typename
            ... on SetGroqKeySuccess {
                success
                status
            }
            ... on GroqKeyError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
